import opener from 'reactApp/utils/opener';

export const openDisko = () => opener('https://disk-o.cloud/?utm_source=cloud&utm_medium=subscription&utm_campaign=pro_tariff');
